/**
 * This directive can be used to have different background assigned for screen of different width
 */
angular.module("iconoglobe").directive("responsiveBg", [function () {
    return {
        restrict: "A",
        scope: {
            onloadBackground: "&"
        },
        link: function (scope, element, attributes) {
            var image = new Image();
            var imgSrc = undefined;
            image.onload = function () {
                // the image must have been cached by the browser, so it should load quickly
                scope.$apply(function () {
                    element.css({backgroundImage: 'url("' + imgSrc + '")'});
                });
                // Call the on load function
                scope.onloadBackground();
            };
            var width = window.innerWidth;
            if (width < 640 && attributes.mobileImg) {
                imgSrc = attributes.mobileImg;
            } else if (width < 1007 && attributes.tabImg)
                imgSrc = attributes.tabImg;
            else if (attributes.desktopImg)
                imgSrc = attributes.desktopImg;
            if (!imgSrc)
                imgSrc = attributes.responsiveBg;
            console.log("Chosen image for screen size [" + width + "] is [" + imgSrc + "]");
            image.src = imgSrc;
        }
    };
}]);